import React, { Component } from 'react';
import DataTable from '@nextiva/crm-datatable';
import sizeMe from 'react-sizeme';
import { sum } from 'lodash';

const isRelativeWidth = value =>
  typeof value === 'string' && value.indexOf('%') !== -1;
const isInt = value => typeof value === 'number';
const toInt = width => parseInt(width, 10);
const normalize = ({ width }) => width;

const CHECKBOXES_WIDTH = 16;
const ACTIONS_WIDTH = 24;
const ACTIONS_CHECKBOXES_MARGIN = 10;
const PREVIEW_WIDTH = 20;

class AdminTable extends Component {
  calculateWidth = (itemWidth, width, relativeWith) => {
    const px = width * (toInt(itemWidth) / relativeWith);

    return Math.floor(px);
  };

  calculateMetaColumnWidth() {
    const {
      disableCheckboxes,
      renderActions,
      shouldRenderPreviewIcon,
    } = this.props;
    let width = 0;

    if (!disableCheckboxes) width += CHECKBOXES_WIDTH;
    if (renderActions) width += ACTIONS_WIDTH;
    if (!disableCheckboxes && !!renderActions)
      width += ACTIONS_CHECKBOXES_MARGIN;
    if (shouldRenderPreviewIcon) width += PREVIEW_WIDTH;
    if (width > 0) width += 20; // padding-left: 12; padding-right: 6; 2px for other bugs;

    return width;
  }

  render() {
    const { children, displayPreferences, size, ...other } = this.props;
    const widthArray = displayPreferences.map(normalize);

    const relativeValues = widthArray.filter(isRelativeWidth).map(toInt);
    const relativeWith = sum(relativeValues);

    const fixedValues = widthArray.filter(isInt);
    const fixedWith = sum(fixedValues);

    const width = size.width - fixedWith - this.calculateMetaColumnWidth();
    const updatedPreferences = displayPreferences.map(item => ({
      ...item,
      width: isRelativeWidth(item.width)
        ? this.calculateWidth(item.width, width, relativeWith)
        : item.width,
    }));

    return (
      <DataTable {...other} displayPreferences={updatedPreferences}>
        {children}
      </DataTable>
    );
  }
}

export default sizeMe()(AdminTable);
